import { render, staticRenderFns } from "./PromptCancellation.vue?vue&type=template&id=52be3bb8&scoped=true&"
import script from "./PromptCancellation.vue?vue&type=script&lang=ts&"
export * from "./PromptCancellation.vue?vue&type=script&lang=ts&"
import style0 from "./PromptCancellation.vue?vue&type=style&index=0&id=52be3bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be3bb8",
  null
  
)

export default component.exports